import { ForwardRefExoticComponent, RefAttributes, forwardRef } from 'react';
import type { StepperProps, StepperRef } from './interface';

import { AnimatedStepItem } from '../jdshorizontalstepitem/animated-stepItem/animated-stepItem';
import { useStepper } from './stepperLogic';

export const withLogic = (
  Component: React.ComponentType<StepperProps>
): ForwardRefExoticComponent<
  Omit<StepperProps, 'ref'> & RefAttributes<StepperRef>
> =>
  forwardRef<StepperRef, StepperProps>((props, stepperRef) => {
    const { stepItems, animateState } = useStepper(props, stepperRef);
    return (
      <Component
        {...{
          ...props,
          stepItems,
          content: (
            <div>
              {stepItems.map((item, i) => (
                <AnimatedStepItem
                  key={i}
                  animateState={animateState}
                  show={item.state === 'active'}
                >
                  {item.children}
                </AnimatedStepItem>
              ))}
            </div>
          )
        }}
      />
    );
  });
export { StepperRef, StepperProps };
